@if (isChatEnabled()) {
    <div class="TotemCustomerCareBook bg-light">
        @if (isLoading) {
            <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
        }
        <div class="container pt-3 bg-white">
            <div class="row">
                <div class="col">
                    <button type="button" class="btn btn-link TotemCustomerCareBook-Back" (click)="goBackToTotem()">
                        <i class="ms-2 fa-regular fa-xs fa-chevron-left" aria-hidden="true"></i>
                        <span>{{ 'totem-customer-care-book.back-totem' | locTranslate }}</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col form-group">
                    <h1 class="m-0 h2">{{ 'totem-customer-care-book.book-customer-care' | locTranslate }}</h1>
                </div>
            </div>
        </div>
        <div class="container py-3 bg-white">
            @if (bookingRequested) {
                <div class="row">
                    <div class="col">
                        <div class="alert alert-success" role="status">
                            <h2 class="h4">{{ 'totem-customer-care-book.thanks' | locTranslate }}</h2>
                            <div>{{ 'totem-customer-care-book.thanks-more' | locTranslate }}</div>
                        </div>
                    </div>
                </div>
            }
            @if (!bookingRequested) {
                <div class="row">
                    <div class="col form-group">
                        <label id="totem-book-language-label">
                            <b>{{ 'totem-customer-care-book.language' | locTranslate }}</b>
                            <i class="ms-2 fa-regular fa-xs fa-asterisk {{ !selectedLanguage ? 'text-danger' : 'text-secondary'}}" aria-hidden="true" [attr.title]="'totem-customer-care-book.required-field' | locTranslate"></i>
                            <span class="visually-hidden">{{ 'totem-customer-care-book.required-field' | locTranslate }}</span>
                        </label>
                        <div role="group" aria-labelledby="totem-book-language-label">
                            <app-pg-select fieldId="totem-book-language" [ariaLabel]="'totem-customer-care-book.language' | locTranslate" [options]="languageOptions" [required]="true" [disabled]="isLoading" [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange()"></app-pg-select>
                        </div>
                    </div>
                </div>
                @if (!isLoading) {
                    <div class="row">
                        <div class="col form-group">
                            <label id="totem-book-availability-label">
                                <b>{{ 'totem-customer-care-book.availability' | locTranslate }}</b>
                                <i class="ms-2 fa-regular fa-xs fa-asterisk {{ !selectedAvailability ? 'text-danger' : 'text-secondary'}}" aria-hidden="true" [attr.title]="'totem-customer-care-book.required-field' | locTranslate"></i>
                                <span class="visually-hidden">{{ 'totem-customer-care-book.required-field' | locTranslate }}</span>
                            </label>
                            <div role="group" aria-labelledby="totem-book-availability-label">
                                <app-pg-availability-select availabilityType="user" [availabilityData]="filteredAvailabilityData" (availabilitySelected)="onAvailabilitySelected($event)"></app-pg-availability-select>
                            </div>
                            <div class="mt-2" role="status">
                                @if (!selectedAvailability) {
                                    <span class="text-muted">{{ 'totem-customer-care-book.no-availability-selected' | locTranslate }}</span>
                                }
                                @if (selectedAvailability) {
                                    <span>
                                        {{ 'totem-customer-care-book.availability-selected' | locTranslate }} <b>{{ 'totem-customer-care-book.field-date' | locTranslate }}</b> {{ selectedAvailability.date | locFormat:'date' }} <b>{{ 'totem-customer-care-book.field-time' | locTranslate }}</b> {{ selectedAvailability.begin | locFormat:'time' }} - {{ selectedAvailability.end | locFormat:'time' }}
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group">
                            <div>
                                <label for="totem-book-name">
                                    <b>{{ 'totem-customer-care-book.name' | locTranslate }}</b>
                                    <i class="ms-2 fa-regular fa-xs fa-asterisk {{ !editUserContact?.name ? 'text-danger' : 'text-secondary'}}" aria-hidden="true" [attr.title]="'totem-customer-care-book.required-field' | locTranslate"></i>
                                    <span class="visually-hidden">{{ 'totem-customer-care-book.required-field' | locTranslate }}</span>
                                </label>
                                <input id="totem-book-name" type="text" class="form-control" [(ngModel)]="editUserContact.name" autocomplete="name" [attr.aria-required]="true"/>
                            </div>
                            <div class="mt-3">
                                <label id="totem-book-contact-label">
                                    <b>{{ 'totem-customer-care-book.contact' | locTranslate }}</b>
                                    <i class="ms-2 fa-regular fa-xs fa-asterisk {{ !editUserContact?.via ? 'text-danger' : 'text-secondary'}}" aria-hidden="true" [attr.title]="'totem-customer-care-book.required-field' | locTranslate"></i>
                                    <span class="visually-hidden">{{ 'totem-customer-care-book.required-field' | locTranslate }}</span>
                                </label>
                        <div role="group" aria-labelledby="totem-book-contact-label">
                                <app-pg-recipient id="totem-book-contact" [(ngModel)]="editUserContact.value" (viaChange)="editUserContact.via = $event;" [ariaLabel]="'totem-customer-care-book.contact' | locTranslate"></app-pg-recipient>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group">
                            <label for="totem-book-additional">
                                <b>{{ 'totem-customer-care-book.additional-informations' | locTranslate }}</b>
                            </label>
                            <textarea id="totem-book-additional" class="form-control" [(ngModel)]="additionalInformations"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="button" class="btn btn-primary btn-block" [disabled]="!canRequestBooking()" (click)="requestBooking()">{{ 'totem-customer-care-book.button-request' | locTranslate }}</button>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
}
@else {
    <div class="container py-5">
        <div class="alert alert-warning" role="status">
            {{ 'totem-customer-care-book.chat-disabled' | locTranslate }}
        </div>
    </div>
}
